/* Component Dependencies */
var moduleLinksTemplate = require('templates/moduleLinks.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'moduleLinks',
  template: {
    'moduleLinks': moduleLinksTemplate
  },

  bindEvents: function () {
    this.appendArrow();
  },

  appendArrow: function _appendArrow() {
    var arrow = $("<span>").addClass("t-icon-arrow-right t-font-xxs t-line-height-s");
    this.$el.find('.description-container a').each(function (index) {
      $(this).append(arrow.clone());
    });
  }
});
